<template src="./Details.html">
</template>

<script>
export default {
        props: {
            itemId: {
                type: Number,
                required: true,
            },
        },

        created() {
            this.$store
                .dispatch("doctors/getDetails", this.itemId)
                .then(() => {

                })
                .catch(() => { });
        },
  computed: {
    doctor() {
          return this.$store.state.doctors.doctor;
      }
  },
};
</script>